import { Box, Menu, styled } from "@mui/material";

export const StyledContextMenu = styled(Box)(({theme}) => ({
    position:"absolute",
    display: "flex",
    flexDirection:"column",
    background: theme.color.background,
    right: "2rem",
    boxShadow: `2px 4px 21px 0px ${theme.contrast.lighter}`,
    borderRadius: "10px",
    zIndex: "99",
    top: ".5rem",
    ".menuItem": {
        display: "flex",
        gap: "0.25rem",
        position: "relative",
        h5: {
            fontWeight: "600",
            color: theme.color.dark
        },
        svg: {
            color: theme.color.main
        },
        ".fileInput": {
            position:"absolute",
            border: "1px solid red",
            opacity: "0",
            width: "100%",
        }
    },
    ".delete": {
        svg: {
            color: theme.palette.error.main
        }
    }
}))